import { saveAs } from 'file-saver';
import { ChangeDetectorRef, Component, OnInit, AfterViewInit } from '@angular/core';
import { OrderService, ProceedStepService } from '@app/api/api';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationStateService } from '@app/services/notification-state.service';
import { Router } from '@angular/router';
import { NotificationService } from '@app/api/notification.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'meu-app-order-management',
  templateUrl: './app-order-management.component.html',
  styleUrls: ['./app-order-management.component.scss']
})
export class AppOrderManagementComponent implements OnInit {
  constructor(
    private notificationStateService: NotificationStateService,
    private cdr: ChangeDetectorRef,
    private orderService: OrderService,
    private changeDetectorRef: ChangeDetectorRef,
    private toastr: ToastrService,
    private proceedStepService: ProceedStepService,
    private router: Router,
    private notificationService: NotificationService,
    private http: HttpClient
  ) {}

  matTableData = new MatTableDataSource();
  displayedColumns: string[] = ['code', 'customer', 'date', 'name', 'money', 'status', 'bill'];
  totalMyOrder: any;
  pagesize: any = 10;
  pageIndex: any = 1;
  loading: boolean = false;
  listOrder: any = [];
  searchStr$ = new Subject();
  searchStr: any = '';
  stepIdSelected = '';
  dateSlected: any = {};
  proceedSteps: any = [];
  filterStringCompare;
  lstProceedSelected: any = [];
  isFirstLoad = true;

  // Thêm dòng này:
  pageSizeOptions: number[] = [5, 10, 20, 100];
  unreadIds: string[] = [];

  ngOnInit() {
    this.searchStr$.pipe(debounceTime(500)).subscribe((value) => {
      this.searchStr = value;
      this.getAllMyOrder(value);
    });

    this.notificationStateService.unreadOrderIds$.subscribe((ids) => {
      this.unreadIds = ids;
      this.applyUnreadStatus();
      this.cdr.detectChanges();
    });
  }
  ngAfterViewInit() {
    this.getAllProcessStep();
  }
  ngOnDestroy() {
    this.changeDetectorRef.detach();
  }
  downloadInvoice(id) {
    this.orderService.apiOrdersIdDownloadInvoiceGet(id).subscribe(
      (res) => {
        saveAs(res);
      },
      (err) => {
        this.toastr.error('Không có hoá đơn');
      }
    );
  }
  getAllMyOrder(filterStr) {
    if (this.isFirstLoad) return;

    let filter = filterStr
      ? `(extend_product_name|code|phone|extend_company_tax_code|fullname)@=${filterStr}`
      : '';
    if (this.lstProceedSelected && this.lstProceedSelected.length > 0) {
      let proceedLength = this.lstProceedSelected.length;
      let selectedStr = '';
      this.lstProceedSelected.map((item, i) => {
        selectedStr = selectedStr + item;
        if (proceedLength === i + 1) {
          return;
        }
        selectedStr = selectedStr + '|';
      });
      filter = filter + (filter ? ',' : '') + `step_id==${selectedStr}`;
    }
    this.dateSlected.startDate && this.dateSlected.endDate
      ? (filter =
          filter +
          (filter ? ',' : '') +
          `created_at >= ${moment(this.dateSlected.startDate).format(
            'DD/MM/YYYY'
          )},created_at <= ${moment(this.dateSlected.endDate).add(1, 'days').format('DD/MM/YYYY')}`)
      : filter;
    this.filterStringCompare !== filter ? (this.pageIndex = 1) : null;
    this.filterStringCompare = filter;
    this.orderService.apiOrdersGet(filter, '', this.pageIndex, this.pagesize).subscribe((res) => {
      if (res.success) {
        this.listOrder = res.data.collection;
        // this.pageIndex = res.data.pageIndex; // Tắt dòng này
        // this.pagesize = res.data.pagesize; // Tắt dòng này
        this.totalMyOrder = res.data.total;

        this.applyUnreadStatus();

        this.listOrder = this.listOrder.map((order) => ({
          ...order,
          is_new: this.unreadIds.includes(order.id)
        }));

        this.matTableData.data = this.listOrder;
        this.loadFinancialDocuments();
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  loadFinancialDocuments() {
    this.listOrder.forEach((order) => {
      this.http.get<any>(`${environment.backendhost}/api/orders/${order.id}/financialDocument`).subscribe(
        (res) => {
          if (res.success && res.data && res.data.length > 0) {
            order.extend_financial_documents = res.data;
            this.changeDetectorRef.detectChanges();
          }
        },
        (err) => {
          console.error('Error loading financial documents for order', order.id, err);
        }
      );
    });
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAllMyOrder(this.searchStr);
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pagesize = newSize;
    this.pageIndex = 1;
    this.getAllMyOrder(this.searchStr);
  }

  moment(date) {
    return moment(date).format('DD/MM/YYYY');
  }
  getAllProcessStep() {
    this.proceedStepService.apiProceedStepsGet('', 'sort_order').subscribe((res) => {
      if (res.success) {
        this.proceedSteps = res.data.collection;
        this.lstProceedSelected = this.proceedSteps
          .filter((item) => !this.isCancelStep(item))
          .map((item) => item.id);
        this.isFirstLoad = false;
        this.getAllMyOrder(this.searchStr);
      }
    });
  }

  private isCancelStep(step: any): boolean {
    if (!step) return false;
    if (step.code === 'Cancel') return true;
    const name = (step.name || '').toString().toLowerCase();
    if (name.includes('đã hủy') || name.includes('da huy')) return true;
    return /(^|\s)hủy(\s|$)/.test(name) || /(^|\s)huy(\s|$)/.test(name);
  }

  onKeyUp(value) {
    this.searchStr$.next(value);
  }
  preventDefault(e) {
    e.preventDefault();
  }
  applyUnreadStatus() {
    if (this.listOrder && this.listOrder.length > 0) {
      this.listOrder = this.listOrder.map((order) => ({
        ...order,
        is_new: this.unreadIds.includes(order.id)
      }));
      this.changeDetectorRef.detectChanges();
    }
  }

  onViewDetail(item: any) {
    if (item.is_new) {
      const filter = `read==false,reference_link@=*/orders/${item.id}`;
      this.notificationService.apiNotificationGet(filter).subscribe((res) => {
        console.log(filter);

        if (res.success && res.data.collection.length > 0) {
          console.log(res);

          const notiId = res.data.collection[0].id;

          this.notificationService.apiNotificationIdReadPut(notiId).subscribe(() => {
            this.notificationStateService.markAsRead(item.id);
          });
        }
      });
    }
    this.router.navigate([`/admin/order/${item.id}/detail`]);
  }

  downloadInvoicePdf(orderId: string, userId: string) {
    if (!orderId) {
      this.toastr.error('Không tìm thấy mã đơn hàng.');
      return;
    }

    if (!userId) {
      this.toastr.error('Không tìm thấy mã người dùng của đơn hàng.');
      return;
    }

    const downloadUrl = `${environment.backendhost}/api/orders?Filters=step_id==${orderId}/download-in-pdf?userId=${userId}&isVat=true`;
    window.open(downloadUrl, '_blank');
  }

  downloadDocument(orderId: string, document: { id: string; name?: string }) {
    if (!document || !document.id) {
      this.toastr.error('Không tìm thấy thông tin file.');
      return;
    }
    const downloadUrl = `${environment.backendhost}/api/orders/${document.id}/downloadFinancial`;
    window.open(downloadUrl, '_blank');
  }

  private triggerDownload(url: string, fallbackFilename: string) {
    this.http.get(url, { responseType: 'blob', observe: 'response' }).subscribe(
      (response: any) => {
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const res = JSON.parse(reader.result as string);
              this.toastr.error(res.message || 'Không thể tải file.');
            } catch (e) {
              this.toastr.error('Không thể tải file.');
            }
          };
          reader.readAsText(response.body);
          return;
        }

        let filename = fallbackFilename;
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
          const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (utf8Match) {
            filename = decodeURIComponent(utf8Match[1]);
          } else {
            const simpleMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
            if (simpleMatch) { filename = simpleMatch[1].trim(); }
          }
        }
        const blobUrl = window.URL.createObjectURL(response.body);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      },
      (err) => {
        console.error(err);
        if (err.error instanceof Blob && err.error.type.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const res = JSON.parse(reader.result as string);
              this.toastr.error(res.message || 'Không thể tải file.');
            } catch (e) {
              this.toastr.error('Không thể tải file.');
            }
          };
          reader.readAsText(err.error);
        } else {
          this.toastr.error('Không thể tải file.');
        }
      }
    );
  }

  downloadReceiptPdf(orderId: string, userId: string) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    const query = userId ? `?userId=${userId}` : '';
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/receipt-pdf${query}`,
      `bien-ban-bao-gia-${orderId}.pdf`
    );
  }

  downloadQuotationPdf(orderId: string, userId: string, voucherValue: number = 0) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    let query = userId ? `?userId=${userId}` : '';
    if (voucherValue) {
      query += (query ? '&' : '?') + `voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/quotation-pdf${query}`,
      `chao-gia-${orderId}.pdf`
    );
  }

  downloadReceiptExcel(orderId: string, userId: string) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    const query = userId ? `?userId=${userId}` : '';
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/receipt-excel${query}`,
      `bien-ban-bao-gia-${orderId}.xlsx`
    );
  }

  downloadQuotationExcel(orderId: string, userId: string, voucherValue: number = 0) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    let query = userId ? `?userId=${userId}&isVat=true` : '?isVat=true';
    if (voucherValue) {
      query += `&voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/quotation-excel${query}`,
      `chao-gia-${orderId}.xlsx`
    );
  }
  downloadContractWord(orderId: string, userId: string, voucherValue: number = 0) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    let query = userId ? `?userId=${userId}` : '';
    if (voucherValue) {
      query += (query ? '&' : '?') + `voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/contract-word${query}`,
      `hop-dong-${orderId}.docx`
    );
  }
}
